import { Article, EditNote, ExpandLess, ExpandMore } from "@mui/icons-material";
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import React, { useState } from "react";
import ManualBulkReturnByProductForm from "./ManualBulkReturnByProductForm";
import ManualBulkReturnByOrderCode from "./ManualBulkReturnByOrderCode";

export default function ManualBulkReturnForm({ returnedFormId, warehouseId }) {
  const [open, setOpen] = useState(true);

  const handleOpen = () => {
    setOpen((prev) => !prev);
  };

  return (
    <>
      <List component="nav">
        <ListItemButton
          onClick={handleOpen}
          sx={{ bgcolor: "var(--light-grey)" }}
        >
          <ListItemIcon>
            <Article />
          </ListItemIcon>
          <ListItemText primary="Trả hàng bằng Mã Đơn hàng" />
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
      </List>
      <Collapse
        in={open}
        timeout="auto"
        unmountOnExit
      >
        <ManualBulkReturnByOrderCode
          warehouseId={warehouseId}
          returnedFormId={returnedFormId}
        />
      </Collapse>

      <List component="nav">
        <ListItemButton
          onClick={handleOpen}
          sx={{ bgcolor: "var(--light-grey)" }}
        >
          <ListItemIcon>
            <EditNote />
          </ListItemIcon>
          <ListItemText primary="Trả hàng theo sản phẩm" />
          {!open ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
      </List>
      <Collapse
        in={!open}
        timeout="auto"
        unmountOnExit
      >
        <ManualBulkReturnByProductForm
          returnedFormId={returnedFormId}
          warehouseId={warehouseId}
        />
      </Collapse>
    </>
  );
}
